var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.39703 17.997V9.80105H9.16203L9.57303 6.59205H6.39703V4.54805C6.39703 3.62205 6.65503 2.98805 7.98403 2.98805H9.66803V0.127047C8.84867 0.0392382 8.02508 -0.00316009 7.20103 4.70959e-05C4.75703 4.70959e-05 3.07903 1.49205 3.07903 4.23105V6.58605H0.332031V9.79505H3.08503V17.997H6.39703Z","fill":"#333333"}));
}

FacebookInline.defaultProps = {"width":"10","height":"18","viewBox":"0 0 10 18","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
